module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fp-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fetch),
      expression: "fetch"
    }],
    attrs: {
      "cols": _vm.cols,
      "dataSource": _vm.dataSource,
      "selectType": _vm.selectType,
      "singleSelectTypeIcon": _vm.singleSelectTypeIcon,
      "singleSelectText": _vm.singleSelectText,
      "size": _vm.size
    },
    on: {
      "onSelect": _vm.handleSelect,
      "onSingleSelect": _vm.handleSingleSelect,
      "onCommandSelect": _vm.handleCommandSelect
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-061e795d"}!./src/shared/libs/ClientFramework/packages/businessElement/BTable/BTable.html
// module id = 912
// module chunks = 80